module.exports = __webpack_public_path__ + "static/media/pdf_icon_white.d71b9756.svg";